<template>
  <el-header>
    <div class="header-left">
      <h2>沉香种植标准管理系统</h2>
    </div>

    <el-menu
      class="header-menu"
      mode="horizontal"
      background-color="#fff"
      text-color="#000"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="/standard" @click="navigateTo('/standard')">
        <el-icon><Menu /></el-icon>
        <span>标准管理</span>
      </el-menu-item>
      <el-menu-item index="/userManage" @click="navigateTo('/userManage')">
        <el-icon><Menu /></el-icon>
        <span>权限管理</span>
      </el-menu-item>
      <!-- <el-menu-item index="/noticeManage" @click="navigateTo('/noticeManage')">
        <el-icon><Menu /></el-icon>
        <span>公告管理</span>
      </el-menu-item>
     
      <el-menu-item index="/mainFrame" @click="navigateTo('/mainFrame')">
        <el-icon><Menu /></el-icon>
        <span>主页</span>
      </el-menu-item> -->
    </el-menu>

    <div class="header-right">
      <el-dropdown @command="handleCommand">
        <span class="user-info">
          {{ userInfo.username }}
          <el-icon><CaretBottom /></el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import { Menu, CaretBottom } from "@element-plus/icons-vue";

const router = useRouter();
const userInfo = ref({
  username: "",
  role: "",
});

onMounted(() => {
  const storedInfo = localStorage.getItem("userInfo");
  if (storedInfo) {
    userInfo.value = JSON.parse(storedInfo);
  }
});

// 路由跳转方法
const navigateTo = (path: string) => {
  router.push(path);
};

const handleCommand = async (command: string) => {
  if (command === "logout") {
    await ElMessageBox.confirm("确定要退出登录吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    router.push("/login");
  }
};
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.header-left {
  flex: 1;
}

.header-menu {
  flex-grow: 1;
  margin: 0 20px;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--el-menu-border-color);
}
.el-menu--horizontal {
  border-right: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
}
</style>
